"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeWindow = exports.getUserId = exports.sendMessages = exports.isInClient = exports.initFreeTextLiff = exports.getLiffId = void 0;
// eslint-disable-next-line import/no-named-as-default -- 暫定対応
var liff_1 = __importDefault(require("@line/liff"));
/**
 * @returns string
 */
var getLiffId = function () {
    var element = document.getElementById("app");
    // 要素を取得できない場合は店舗側と判断する
    if (element === null) {
        return null;
    }
    var liffId = element.dataset.liffId;
    if (liffId === undefined) {
        return null;
    }
    return liffId;
};
exports.getLiffId = getLiffId;
/**
 * LIFFの初期化を行う
 * 初期化完了. 以降はLIFF SDKの各種機能を利用できる
 *  =>初期化前でも使用できる機能もある（liff.isInClient()など）
 */
var initFreeTextLiff = function (liffId, channelId, contentId, scenarioId, setIsError) {
    return liff_1.default
        .init({ liffId: liffId })
        .then(function () {
        var url = "".concat(process.env.MIX_JS_APP_URL, "/admin/liff/free_text?channel_id=").concat(channelId, "&liff_id=").concat(liffId, "&content_id=").concat(contentId, "&scenario_id=").concat(scenarioId);
        //ログインしていなければログインさせる
        // eslint-disable-next-line promise/always-return -- 暫定対応
        if (liff_1.default.isLoggedIn() === false)
            liff_1.default.login({
                redirectUri: url,
            });
    })
        .catch(function (_error) {
        setIsError(true);
    });
};
exports.initFreeTextLiff = initFreeTextLiff;
/**
 * LIFFアプリをLIFFブラウザで動作させているかどうか
 */
var isInClient = function () {
    return liff_1.default.isInClient();
};
exports.isInClient = isInClient;
/**
 * LIFFアプリが開かれているトーク画面にメッセージを送信
 */
var sendMessages = function (answer) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, liff_1.default.sendMessages([
                    {
                        type: "text",
                        text: "【質問回答】" + "\n" + answer,
                    },
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.sendMessages = sendMessages;
/**
 * ユーザーID取得
 */
var getUserId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var profile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, liff_1.default.getProfile()];
            case 1:
                profile = _a.sent();
                return [2 /*return*/, profile.userId];
        }
    });
}); };
exports.getUserId = getUserId;
/**
 * LIFFアプリを閉じる
 */
var closeWindow = function () {
    liff_1.default.closeWindow();
};
exports.closeWindow = closeWindow;
